export function AuthDivider() {
  return (
    <div className="relative my-6">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-white/20" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full text-white/70">
          or
        </span>
      </div>
    </div>
  )
}
